export type ProjectStage =
  | 'Inquiry' |'Requirement' |'Proposal' |'Approval' |'Development' |'Testing' |'Client Review' |'Deployment' |'Maintenance';

export type ServiceType =
  | 'Web Development' |'Mobile App' |'ERP / CRM' |'Custom Software' |'BPO Services' |'Digital Marketing' |'Cloud / Hosting' |'API Integration';

export type Priority = 'Critical' | 'High' | 'Medium' | 'Low';

export interface Project {
  id: string;
  name: string;
  client: string;
  serviceType: ServiceType;
  stage: ProjectStage;
  pm: string;
  teamSize: number;
  budget: string;
  startDate: string;
  deadline: string;
  daysLeft: number;
  completion: number;
  priority: Priority;
}

export const stageVariant: Record<ProjectStage, string> = {
  Inquiry: 'stage-inquiry',
  Requirement: 'stage-requirement',
  Proposal: 'stage-proposal',
  Approval: 'stage-approval',
  Development: 'stage-development',
  Testing: 'stage-testing',
  'Client Review': 'stage-review',
  Deployment: 'stage-deployment',
  Maintenance: 'stage-maintenance',
};

export const priorityVariant: Record<Priority, string> = {
  Critical: 'priority-critical',
  High: 'priority-high',
  Medium: 'priority-medium',
  Low: 'priority-low',
};

export const projects: Project[] = [
  {
    id: 'proj-001',
    name: 'Nexus ERP Platform',
    client: 'Pinnacle Systems',
    serviceType: 'ERP / CRM',
    stage: 'Testing',
    pm: 'Kavya Sharma',
    teamSize: 8,
    budget: '$84,000',
    startDate: 'Mar 10, 2026',
    deadline: 'Sep 15, 2026',
    daysLeft: 33,
    completion: 78,
    priority: 'Critical',
  },
  {
    id: 'proj-002',
    name: 'Halcyon Mobile App',
    client: 'Halcyon Ventures',
    serviceType: 'Mobile App',
    stage: 'Deployment',
    pm: 'Daniel Reeves',
    teamSize: 5,
    budget: '$52,000',
    startDate: 'Jan 22, 2026',
    deadline: 'Aug 20, 2026',
    daysLeft: 7,
    completion: 95,
    priority: 'Critical',
  },
  {
    id: 'proj-003',
    name: 'BlueStar E-Commerce Portal',
    client: 'BlueStar Retail',
    serviceType: 'Web Development',
    stage: 'Development',
    pm: 'Anika Patel',
    teamSize: 6,
    budget: '$38,500',
    startDate: 'May 5, 2026',
    deadline: 'Oct 1, 2026',
    daysLeft: 49,
    completion: 54,
    priority: 'High',
  },
  {
    id: 'proj-004',
    name: 'Vertex CRM Integration',
    client: 'Vertex Inc',
    serviceType: 'API Integration',
    stage: 'Client Review',
    pm: 'Marcus Delgado',
    teamSize: 3,
    budget: '$21,000',
    startDate: 'Jun 1, 2026',
    deadline: 'Aug 10, 2026',
    daysLeft: -3,
    completion: 97,
    priority: 'High',
  },
  {
    id: 'proj-005',
    name: 'Meridian Cloud Migration',
    client: 'Meridian Corp',
    serviceType: 'Cloud / Hosting',
    stage: 'Development',
    pm: 'Kavya Sharma',
    teamSize: 4,
    budget: '$29,400',
    startDate: 'Jun 20, 2026',
    deadline: 'Sep 30, 2026',
    daysLeft: 48,
    completion: 41,
    priority: 'Medium',
  },
  {
    id: 'proj-006',
    name: 'Orbis Retail SEO Campaign',
    client: 'Orbis Retail',
    serviceType: 'Digital Marketing',
    stage: 'Maintenance',
    pm: 'Sofia Navarro',
    teamSize: 2,
    budget: '$14,800',
    startDate: 'Feb 1, 2026',
    deadline: 'Ongoing',
    daysLeft: 999,
    completion: 100,
    priority: 'Low',
  },
  {
    id: 'proj-007',
    name: 'Apex Logistics Custom TMS',
    client: 'Apex Logistics',
    serviceType: 'Custom Software',
    stage: 'Development',
    pm: 'Rajan Mehta',
    teamSize: 9,
    budget: '$112,000',
    startDate: 'Apr 14, 2026',
    deadline: 'Dec 5, 2026',
    daysLeft: 114,
    completion: 33,
    priority: 'High',
  },
  {
    id: 'proj-008',
    name: 'HealthFirst Patient Portal',
    client: 'HealthFirst Medical',
    serviceType: 'Web Development',
    stage: 'Testing',
    pm: 'Priya Nambiar',
    teamSize: 7,
    budget: '$67,000',
    startDate: 'Mar 28, 2026',
    deadline: 'Sep 5, 2026',
    daysLeft: 23,
    completion: 86,
    priority: 'Critical',
  },
  {
    id: 'proj-009',
    name: 'Synapse AI Dashboard',
    client: 'Synapse Analytics',
    serviceType: 'Custom Software',
    stage: 'Proposal',
    pm: 'Daniel Reeves',
    teamSize: 0,
    budget: '$45,000',
    startDate: 'TBD',
    deadline: 'Nov 30, 2026',
    daysLeft: 109,
    completion: 0,
    priority: 'Medium',
  },
  {
    id: 'proj-010',
    name: 'FlexBPO Outbound Campaign',
    client: 'FlexBPO Partners',
    serviceType: 'BPO Services',
    stage: 'Maintenance',
    pm: 'Aisha Okonkwo',
    teamSize: 14,
    budget: '$31,200',
    startDate: 'Jan 10, 2026',
    deadline: 'Ongoing',
    daysLeft: 999,
    completion: 100,
    priority: 'Low',
  },
  {
    id: 'proj-011',
    name: 'Ironclad Security Audit Platform',
    client: 'Ironclad Cyber',
    serviceType: 'Custom Software',
    stage: 'Inquiry',
    pm: 'TBD',
    teamSize: 0,
    budget: 'TBD',
    startDate: 'TBD',
    deadline: 'TBD',
    daysLeft: 999,
    completion: 0,
    priority: 'Medium',
  },
  {
    id: 'proj-012',
    name: 'Solaris ERP Phase 2',
    client: 'Solaris Manufacturing',
    serviceType: 'ERP / CRM',
    stage: 'Development',
    pm: 'Rajan Mehta',
    teamSize: 6,
    budget: '$78,500',
    startDate: 'May 18, 2026',
    deadline: 'Nov 15, 2026',
    daysLeft: 94,
    completion: 27,
    priority: 'High',
  },
];